import { Record } from 'immutable';

export const INVESTMENT_HOLDINGS_V2_REDUCER_KEY = 'investmentHoldingsV2Store';

export const mkInvestmentHoldingV2 = Record({
  clientId: undefined,
  id: undefined,
  createdAt: undefined,
  accountId: undefined,
  quantity: 0,
  costBasis: undefined, //FI aggregated cost basis
  currentPrice: undefined,
  currentPriceAt: undefined,
  marketValue: undefined,
  isDeleted: undefined,
  isCash: undefined,
  localSecurityId: '',
  holdings: undefined,
  securityId: undefined,
  securityIdType: undefined,
  symbol: undefined,
  securityName: undefined,
  sharesPerContract: undefined,
  securityType: undefined,
  userCostBasis: undefined, //User input cost basis
  userCostBasisOn: undefined,
  quantityWhenUserSetCostBasis: undefined,
});

export const columns = Object.freeze([
  { key: 'symbol', label: 'Symbol', align: 'left', padding: 'normal' },
  { key: 'name', label: 'Name', align: 'left', padding: 'normal' },
  { key: 'shares', label: 'Shares', align: 'right', padding: 'normal' },
  { key: 'price', label: 'Price', align: 'right', padding: 'normal' },
  { key: 'value', label: 'Value', align: 'right', padding: 'normal' },
  { key: 'todayValue', label: '1 Day $', align: 'right', padding: 'normal' },
  { key: 'todayPercent', label: '1 Day %', align: 'right', padding: 'normal' },
  { key: 'action', label: '', align: 'right', padding: 'none' },
  { key: 'details', label: '', align: 'right', padding: 'none' },
]);
